<ngx-spinner [zIndex]="20001003" bdColor="rgba(196, 197, 198, 0.5)" size="medium" color="{{coloreLogo}}"
  type="ball-atom" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>
<router-outlet></router-outlet>